import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { AgentOrganization } from './agent-organization.model';
import { Borrower, getPrimaryBorrower } from './borrower.model';
import { DocumentRequest } from './document-request.model';
import { DealStatuses, InsuranceReferralProviderOptions } from './enumerators';
import { MortgageRequest } from './mortgage-request.model';
import { Note } from './note.model';
import { Referral } from './referral.model';
import { SubjectProperty } from './subject-property.model';

@HateoasResource('deal')
export class Deal extends Resource {
  dealId: number;
  loanCode: string;
  dealKey: string;
  purchasePrice?: number;
  closingDate?: Date;
  isRealtorExists: boolean;
  isRealtorNeeded: boolean;
  isRealtorReferredToUs: boolean;
  status: DealStatuses;
  organization: AgentOrganization;
  subjectProperty: SubjectProperty;
  primaryMortgageRequest: MortgageRequest;
  borrowers: Array<Borrower>;
  note: Note;
  referral: Referral;
  documentRequests: Array<DocumentRequest>;
  insuranceSupplierId: number;

  getPrimaryBorrower() {
    return getPrimaryBorrower(this.borrowers);
  }
}
